import { PostDto } from '../../../../common/interfaces/infoboard.interface';
import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { ReactComponent as ImportantIcon } from '../../../../assets/important-icon.svg';
import { ReactComponent as EditIcon } from '../../../../assets/edit-icon.svg';
import { ReactComponent as WarningIcon } from '../../../../assets/warning-icon.svg';
import dayjs from 'dayjs';
import GenericFile from '../../../../components/GenericFile';
import { useNavigate } from 'react-router-dom';
import { ProfilePictureAvatar } from '../../../../common/styles/Common.styles';
import { WarningBox } from '../PostPage/PostPage.styles';
import { TopRightEditImportantBox } from './PostItem.styles';
import { INFOBOARD } from '../../../../common/constants/routes.constants';
import { useTranslation } from 'react-i18next';

import { palette } from '../../../../theme';
interface PostItemProps {
  post: PostDto;
}

const PostItem: React.FC<PostItemProps> = ({ post }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleEdit = () => {
    navigate(`${INFOBOARD}/post/${post.id}/edit`);
  };
  return (
    <Box
      sx={{
        border: post.important ? '1px solid rgba(229, 128, 122, 0.35)' : `1px solid ${palette.line}`,
        borderRadius: '10px',
        position: 'relative'
      }}
    >
      <Box
        sx={{
          padding: '16px 12px',
          borderBottom: `1px solid ${palette.line}`,
          backgroundColor: palette.surface.subtle,
          borderTopLeftRadius: '10px',
          borderTopRightRadius: '10px'
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <ProfilePictureAvatar src={post.creatorPicture ?? undefined} width={48} height={48}></ProfilePictureAvatar>
          <Box>
            <Typography variant="caption">{post.createdBy}</Typography>
            <Typography variant="body2" color="text.secondary">
              {dayjs(post.updatedAt).format('DD.MM.YYYY. HH:mm')}
            </Typography>
          </Box>
        </Box>

        {(post.canEdit || post.important) && (
          <TopRightEditImportantBox important={post.important}>
            {post.canEdit && (
              <IconButton onClick={handleEdit} sx={{ p: 1 }} size="small">
                <EditIcon width={20} height={20} />
              </IconButton>
            )}

            {post.important && (
              <WarningBox>
                <ImportantIcon style={{ width: 15, height: 15, display: 'block' }} />
                <Typography variant="caption" color="error" fontWeight={600}>
                  {t('infoboard.important')}
                </Typography>
              </WarningBox>
            )}
          </TopRightEditImportantBox>
        )}
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: '24px',
          padding: '12px'
        }}
      >
        <Typography variant="body1" color={palette.text.secondary}>
          {post.description}
        </Typography>
        {post.hasPollItem && (
          <Box
            sx={{
              display: 'flex',
              gap: 1,
              color: palette.text.link
            }}
          >
            <WarningIcon />
            <Typography variant="body1">{t('infoboard.pollDetailsInApp')}</Typography>
          </Box>
        )}
      </Box>

      {post.files && post.files.length > 0 && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: '12px',
            padding: '12px',
            flexWrap: 'wrap'
          }}
        >
          {post.files.map(file => (
            <GenericFile key={file.id} file={file} />
          ))}
        </Box>
      )}
    </Box>
  );
};
export default PostItem;
